import { defaultMutations } from 'vuex-easy-access'
import { APP_CONFIG } from '../../config.js'
import AlbumAPI from '../../api/album.js'

const state = {
    mostRecentAlbumList: null,
    mostRecentAlbumListLoadStatus: 0,
    mostRecentAlbumListPagination: null
}

// add generate mutation vuex easy access
// https://mesqueeb.github.io/vuex-easy-access/setup.html#setup
const mutations = { ...defaultMutations(state) }

const getters = {
    getMostRecentAlbumList: state => () => state.mostRecentAlbumList,
    getMostRecentAlbumListLoadStatus: state => () => state.mostRecentAlbumListLoadStatus,
    getMostRecentAlbumListPagination: state => () => state.mostRecentAlbumListPagination
}

const actions = {
    getMostRecentAlbumList ({ commit }, data) {
        commit('mostRecentAlbumListLoadStatus', 1)

        AlbumAPI.getMostRecentAlbumList(data.page, data.perPage)
        .then((response) => {
            commit('mostRecentAlbumListLoadStatus', 2)
            commit('mostRecentAlbumList', response.data.albums.data)
            commit('mostRecentAlbumListPagination', response.data.albums)
        })
        .catch( function( e ) {
            commit('mostRecentAlbumListLoadStatus', 3)
            commit('mostRecentAlbumList', {})
            commit('mostRecentAlbumListPagination', {})
        })
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
